import { Skeleton } from "@mantine/core";
import { useEffect, useState } from "react";
import { ProductCategory } from "../../api/ProductCategory";
import useProductCategoryManager from "../../hooks/useProductCategoryManager";

export default function NavbarProductCategoryDropdownContent() {
  const { data: productCategoryData, isLoading } =
    useProductCategoryManager().getProductCategory();

  const [lastHoverItem, setLastHoverItem] = useState<
    ProductCategory | undefined
  >(undefined);

  function getParentCategory() {
    if (productCategoryData === undefined) return undefined;
    return productCategoryData
      .sort((a, b) => a.index - b.index)
      .filter((cat) => cat.children !== null);
  }

  function handleHoverToParentCategoryItem(category: ProductCategory) {
    console.log(`User is hover to parent category ${category.name}`);
    setLastHoverItem(category);
  }

  /**
   * Initial load the last hover item category to a index 0 of parent category.
   * Use effect
   */
  useEffect(() => {
    if (productCategoryData && productCategoryData.length > 0) {
      setLastHoverItem(productCategoryData[0]);
    }
  }, [productCategoryData]);

  

  /**
   * [ parent | children a | children b  ]
   * [ . hover| ........   | ........ ]
   */
  return (
    <>
      <div className="flex flex-row mx-16 text-sm">
        <div className="border-r w-1/6">
          <h4 className="font-bold my-2">Danh mục sản phẩm</h4>
          <div className="flex flex-col gap-1">
            {isLoading ? (
              <>
                <a className="hover:underline p-3">
                  <Skeleton className="w-full h-[24px]" />
                </a>

                <a className="hover:underline p-3">
                  <Skeleton className="w-full h-[24px]" />
                </a>

                <a className="hover:underline p-3">
                  <Skeleton className="w-full h-[24px]" />
                </a>
              </>
            ) : (
              <>
                {getParentCategory()?.map((item) => {
                  return (
                    <a
                      className="hover:underline p-2 px-4 cursor-pointer hover:bg-neutral-200 rounded-l-xl"
                      key={item.id}
                      onMouseOver={() => handleHoverToParentCategoryItem(item)}
                      href={`/product?category=${item.id}`}
                    >
                      {item.name}
                    </a>
                  );
                })}
              </>
            )}
          </div>
        </div>

        {/* Children wrapper */}
        <div className="navbar-category-dropdown-content-wrapper w-5/6 p-4">
          {isLoading ? (
            <div className="grid grid-cols-3 gap-4">
              {/* Make skeletons */}
              <Skeleton>Hi</Skeleton>
              <Skeleton>Hi</Skeleton>
              <Skeleton>Hi</Skeleton>
              <Skeleton>Hi</Skeleton>
              <Skeleton>Hi</Skeleton>
              <Skeleton>Hi</Skeleton>
              <Skeleton>Hi</Skeleton>
              <Skeleton>Hi</Skeleton>
              <Skeleton>Hi</Skeleton>
              <Skeleton>Hi</Skeleton>
              <Skeleton>Hi</Skeleton>
              <Skeleton>Hi</Skeleton>
            </div>
          ) : (
            <>
              {/* Last hover item children */}
              {(lastHoverItem && lastHoverItem?.children && (
                <>
                  <div className="grid grid-cols-3 gap-4">
                    {lastHoverItem.children.map((child) => {
                      return (
                        <a
                          href={`/product?category=${child.id}`}
                          className="hover:bg-neutral-200 p-2 hover:underline"
                          key={child.index}
                        >
                          {child.name}
                        </a>
                      );
                    })}
                  </div>
                </>
              )) || <>Danh mục {lastHoverItem?.name} Không có danh mục con</>}
            </>
          )}
        </div>
      </div>
    </>
  );
}
